<script setup lang="ts">
// Sierra's .kv: a title with a muted line under it (`meta`), and a mono `value` at the
// end. Slots: `start` before the title, the default to replace the title block, and
// `end` after the value. Rows sit in a flush Panel, divided by hairlines.
// `interactive` adds the hover tint.
withDefaults(defineProps<{ title?: string | undefined; meta?: string | undefined; value?: string | number | undefined; interactive?: boolean }>(), {
  interactive: false,
});
</script>

<template>
  <div class="itc-data-row" :class="{ 'itc-data-row--interactive': interactive }">
    <slot name="start" />
    <div class="itc-data-row__main">
      <slot>
        <div class="itc-data-row__title">{{ title }}</div>
        <div v-if="meta" class="itc-data-row__meta">{{ meta }}</div>
      </slot>
    </div>
    <div v-if="value !== undefined || $slots.end" class="itc-data-row__end">
      <span v-if="value !== undefined" class="itc-data-row__value">{{ value }}</span>
      <slot name="end" />
    </div>
  </div>
</template>
